function App() {
  return (
      // eslint-disable-next-line react/style-prop-object
      <div className="App">
          <h1>From Develop to Main</h1>
          <h2>Release - testing 1</h2>


      </div>
  );
}

export default App;

